export enum DataFieldVisibleForType {
    Everyone = 1,
    LocalManagersOrHigher = 2,
    CentralManagersOrHigher = 3,
    GlobalManagersOrHigher = 4,
    AdminOnly = 100,
}
